import * as React from "react"

const SvgRecommendationPaid = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.954 4.26q3.198-.839 6.099.836.52.3.995.676.477.376.874.837.306.32.253.737a.9.9 0 0 1-.426.663q-.36.225-.76.168a1.2 1.2 0 0 1-.706-.379 4 4 0 0 0-.573-.533 6 6 0 0 0-.657-.437q-2.187-1.261-4.588-.628-2.401.634-3.652 2.8l-.087.151 1.23-.33a.95.95 0 0 1 .743.113.95.95 0 0 1 .469.588q.1.375-.112.743a.95.95 0 0 1-.588.47l-3.552.95a.96.96 0 0 1-.756-.09.96.96 0 0 1-.456-.61l-.952-3.55a.95.95 0 0 1 .112-.745.95.95 0 0 1 .588-.468.95.95 0 0 1 .744.111.95.95 0 0 1 .469.589l.329 1.23L5.08 8q1.675-2.902 4.873-3.74" />
    <path
      fillRule="evenodd"
      d="M12.342 20.009a6 6 0 0 1-.345-1.998q-1.57.01-3.043-.84-.346-.201-.657-.437a4 4 0 0 1-.572-.533 1.23 1.23 0 0 0-.716-.385 1.1 1.1 0 0 0-.77.161.85.85 0 0 0-.414.642.86.86 0 0 0 .231.725q.42.473.889.86.469.386 1.01.699 2.115 1.221 4.387 1.106M18.99 15.873l.025.014-.01-.039z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m19.015 15.888-.01-.04-.015.025z"
      clipRule="evenodd"
    />
    <path d="M15.832 17.564q.393.406 1.135.74.306.137.67.262.834.26 1.18.543.348.282.348.634 0 .32-.3.574-.302.252-.842.252-.277 0-.61-.184a1.8 1.8 0 0 1-.578-.52 1.07 1.07 0 0 0-.517-.412.9.9 0 0 0-.61 0 .76.76 0 0 0-.486.428.72.72 0 0 0-.007.627q.277.566.81.986t1.227.604v.199q0 .305.208.504.208.2.486.199a.61.61 0 0 0 .455-.199.7.7 0 0 0 .193-.504v-.153q.987-.184 1.62-.849.633-.664.633-1.552 0-.979-.532-1.567-.532-.589-1.66-.971-.24-.082-.443-.159-.705-.266-.945-.468-.309-.26-.309-.55 0-.261.255-.444t.687-.183q.215 0 .44.068.224.069.362.207.15.116.288.197l.015-.025.01.04q.18.102.343.147a.87.87 0 0 0 .548-.008.76.76 0 0 0 .455-.466.65.65 0 0 0-.085-.62 2.2 2.2 0 0 0-.733-.68 3.6 3.6 0 0 0-.949-.374v-.184a.7.7 0 0 0-.185-.504.62.62 0 0 0-.479-.199.66.66 0 0 0-.478.199.68.68 0 0 0-.2.504v.184q-1.02.23-1.497.879-.144.196-.245.394a2.1 2.1 0 0 0-.234.944q0 .462.152.84a1.9 1.9 0 0 0 .404.62" />
  </svg>
)
export default SvgRecommendationPaid
